// extracted by mini-css-extract-plugin
export default {"extraheader":"Table_extraheader__8Im+j","taskassigned":"Table_taskassigned__LijZZ"};